const AtomEmpty = {
    baseStyle: {}
}

export default AtomEmpty;